import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CalendarDataService {

    constructor() { }

    GetEventEndDate(endDate: any): any {

        // Adding one second to the endDate property if multi-day event ending on Sunday since on week view plugin somehow does not display this event on Sunday itself.
        // This also does not break all the rest functionality (probably).
        if (endDate && moment(endDate).isValid() && moment(endDate).weekday() === 0) {
            return new Date((moment(endDate).add(1, 'seconds')).toString());
        }

        return endDate ? new Date(endDate) : null;
    }

}
